module.exports = __webpack_public_path__ + "static/media/sum_customer_info.204a4f59.png";